import styled, {keyframes} from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const EditAvatarWrapper = styled.div<{ rowLength: number }>`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  height: 300px;
  overflow-y: scroll;
  max-width: 100%;
  justify-content: center;

  & > * {
    width: calc(25% - 1em);
    margin-bottom: 1em;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  @media (max-width: 1024px) {
    & > * {
      width: calc(33.33% - 1em);
    }

    &:nth-child(n + ${(props) => props.rowLength - 3}) {
      margin-left: 0;
    }
  }

  @media (max-width: 768px) {
    & > * {
      width: 33%;
    }
  }

  @media (max-width: 480px) {
    & > * {
      width: 50%;
      margin-right: 0;
      margin-bottom: 0.5em;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  &:after {
    content: "";
    flex: auto;
  }

  ${({ rowLength }) =>
    rowLength % 4 !== 0 &&
    `:after {
      content: "";
      width: calc(50% - 1em * ${rowLength % 4});
      flex: none;
    }

    @media (max-width: 1024px) {
      &:after {
        width: calc(33.33% - 1em * ${rowLength % 3});
      }
    }

    @media (max-width: 480px) {
      &:after {
        width: calc(50% - 1em * ${rowLength % 2});
      }
    }

    @media (max-width: 360px) {
      &:after {
        width: 100%;
      }
    }

    `}
`;
export const EditAvatarImage = styled.img<{
    active: boolean
}>`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  cursor: pointer;
  ${({ active }) => (
          active &&
          `
      border: 2px solid #8ab7ec;
      transition: border-color 0.2s ease-in-out;
    `
  )}
`;


export const EditAvatarOverlay = styled.div`
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background: none;
  }
`;

export const UploadImageMainContainer = styled.div`
    padding: 10px 5px;
    background-color: #ffffff;
    border-radius: 10px;
    cursor: pointer;
    -webkit-transition: border 0.2s ease-in-out;
    transition: border 0.2s ease-in-out;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    border: none;
    height: 180px;
`

export const UploadImageDropZoneWrapper = styled.div`
    padding: 0 5px;
    width: 100%;
`

export const UploadImageDropZone = styled.div`
    background: #ecf3fc;
    height: 90%;
    border: 1px dashed #8ab7ec;
    color: #8ab7ec;
    padding: 10px;
    display: block;
    border-radius: 8px;
    text-align: center;
`

export const UploadTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const UploadIcon = styled(FontAwesomeIcon)`
    font-size: 34px;
    margin-bottom: 8px;
`

export const UploadText = styled.span`
    color: #8ab7ec;
    font-weight: bold;
    font-family: Roboto, sans-serif;
`

export const UploadInputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 18px 72px;
`
export const UploadInput = styled.input`
    margin: 0 48px;
`

export const TopControlsWrapper = styled.div`
    display: flex;
    margin: 1em 0;
`

export const BackButton = styled(FontAwesomeIcon)`
    color: #2164db;
    font-size: 1.5em;
    &:hover {
        cursor: pointer;
        color: #0a0a0a;
    }
`

export const AvatarText = styled.p`
    text-align: center;
    font-size: 1em;
    font-weight: 400;
    margin: 0 0 0 1.2em;
    line-height: 1.5;
`
export const ButtonsWrapper = styled.div`
    text-align: right;
    padding: 8px;
`

export const DragFileElement = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
`

export const ButtonSpinner = styled.button`
  display: inline-block;
  appearance: none;
  padding: 0.35em 1.5em;
  margin: 0 0.3em 0 0;
  border: 3px solid;
  border-radius: 1.5em;
  background: none;
  color: grey;
  font-weight: 600;
  font-size: 1.1em;
  transition: all 0.2s ease;
  cursor: pointer;
  vertical-align: middle;
  white-space: nowrap;
`

export const spinAnimation = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SpinnerIcon = styled(FontAwesomeIcon)`
  font-size: 2em;
  animation: ${spinAnimation} 1s linear infinite;
`

export const Label = styled.div<{ color: string }>`
  background: ${({ color }) =>
          color === 'error'
                  ? 'rgba(219, 1, 0, 0.8)'
                  : color === 'warning'
                          ? 'rgba(233, 164, 38, 0.8)'
                          : color === 'info'
                                  ? 'rgba(33, 101, 219, 0.8)'
                                  : color === 'success'
                                          ? 'rgba(81, 214, 115, 0.8)'
                                          : 'none'};
  padding: 4px;
  border-radius: 50px;
  height: 28px;
  margin: 0 auto;
  margin-bottom: 12px;
  opacity: ${({ color }) => (color !== 'none' ? '1' : '0')};
  transition: opacity 0.3s ease-in-out;
`;

export const LabelText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.8em;
  text-align: center;
  opacity: ${({ color }) => (color !== 'none' ? '1' : '0')};
  transition: opacity 0.3s ease-in-out;
`;

